export default "__VITE_ASSET__YrEkATdg__"